import React from 'react'
import styled, { css, theme } from '../../theme'

const Wrapper = styled.div<IButton>`
  min-width: 155px;
  height: 30px;
  border-radius: 4px;
  background-color: #696a6d;
  background-size: cover;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  color: #ffffff;
  text-decoration: none solid rgb(255, 255, 255);
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props =>
    props.secondary &&
    css`
      background-color: #bababa;
    `}
  ${props =>
    props.primary &&
    css`
      background-color: ${theme.colors.palette.emerald};
    `}
`

function Button({
  children,
  secondary,
  primary,
  onClick,
  style = {},
}: IButton) {
  return (
    <Wrapper
      onClick={onClick}
      primary={primary}
      secondary={secondary}
      style={style}
    >
      {children}
    </Wrapper>
  )
}

export interface IButton {
  secondary?: boolean
  children: any
  onClick: any
  primary?: boolean
  style?: React.CSSProperties
}

export default Button
